const initBlock = async function( block ) {
	const scrollBtn = block.find( "[data-scroll-button]" );

	scrollBtn.on( "click", function() {
		let nextSection = block.siblings( ".section" ).first();

		if ( !nextSection.length ) {return;}

		let scrollHeight = nextSection.offset().top;
		let headerHeight = 0;
		let adminbarHeight = 0;

		if ( $( ".section-header" ).length ) {
			headerHeight = $( ".section-header" ).outerHeight();
		}

		if ( $( "#wpadminbar" ).length ) {
			adminbarHeight = $( "#wpadminbar" ).outerHeight();
		}


		let resultScrollHeight = scrollHeight - headerHeight - adminbarHeight;

		window.scrollTo( {top: resultScrollHeight} );
	} );
};

themeUtils.loadBlock( initBlock, "hero", ".section-hero" );
